export default __webpack_public_path__ + "locales/lv/DeleteThirdPartyDialog.json?hash=50b4d75f24114d25f1ad3e11dcda5a70";